"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MachineList_1 = require("../../sections/machine-list/MachineList");
const MachineList = ({ title }) => {
    return (0, jsx_runtime_1.jsx)(MachineList_1.MachineList, { title: title });
};
exports.MachineList = MachineList;
